import InputSelect from "global/InputSelect/InputSelect";
import InputText from "global/InputText/InputText";
import MultiLineText from "global/MultiLineText/MultiLineText";
import { useFetchOptions } from "global/hooks/useFetchOptions";
import { useEffect, useRef, useState } from "react";
import { getUrls } from "services/api.enums";
import { searchByCity } from "tools/functions/Methods";

import { useSelector } from "react-redux";
import InputNumber from "global/InputNumber/InputNumber";
import { getAPI } from "services/CRUDServices";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { BsUpcScan } from "react-icons/bs";
import useSearchCity from "pages/order-management-easy/hooks/useSearchCity";
import { useSpeechRecognize } from "pages/order-management-easy/hooks/useSpeech-recognize";
import useHandleKeyDown from "pages/order-management-easy/hooks/useHandleKeyDown";
import { RenderIcon } from "pages/order-management-easy/components/render-icon";
import { TiInfoOutline } from "react-icons/ti";

const Receiver = ({ formik, submitAndNew, freeBardoce, setFreeeBarcode }) => {
  const { values, setFieldValue, handleChange, errors, touched } = formik;
  const reciverRef = useRef(null);
  const [openScan, setOpenScan] = useState(false);
  const { orderManagementData } = useSelector((state: any) => state.orderData);
  const [disableSupport, setDisableSupport] = useState(true);
  const reveiverRef = useRef(null);
  const { dataOptions: contentType } = useFetchOptions(getUrls.findByCity);
  const { handleChangeCity } = useSearchCity(
    setFieldValue,
    setDisableSupport,
    contentType?.options
  );
  const { startListening, stopListening, isListening } = useSpeechRecognize(
    setFieldValue,
    handleChange,
    handleChangeCity
  );

  const { handleKeyDown } = useHandleKeyDown(startListening, stopListening);

  useEffect(() => {
    orderManagementData && reveiverRef?.current?.focus();
  }, []);

  const { currenthub } = useSelector((state: any) => state.userInfo);

  async function getFreeBarcode() {
    try {
      setFreeeBarcode({ ...freeBardoce, loading: true });
      const res = await getAPI(
        `/consignment-api/label/getFreeLabelFromHub/${currenthub?.id}`
      );
      setFreeeBarcode({ data: res.data.serialNumber, loading: false });
      setFieldValue("cprNumber", res.data.serialNumber);
    } catch {
      setFreeeBarcode({ ...freeBardoce, loading: false });
    }
  }

  useEffect(() => {
    reciverRef?.current?.focus();
  }, []);

  return (
    <>
      <h1 className=" text-lg font-semibold">اطلاعات گیرنده</h1>
      {!orderManagementData && (
        <div
          className="flex items-center p-4 mb-4 text-sm text-tomato rounded-lg bg-blue-50 border border-blue-200"
          role="alert"
        >
          <TiInfoOutline className="ml-2 text-lg" />
          <span className="font-medium">
            لطفا ابتدا مشخصات سرپرست را وارد کنید
          </span>
        </div>
      )}
      <div className="grid grid-cols-3 Max-md:grid-cols-1 items-center max-w-6xl Max-md:flex-col gap-x-4 gap-y-4 mt-6 mb-4 ">
        <InputText
          ref={reciverRef}
          label="شماره گذرنامه"
          name="receiver.passportCode"
          handleChange={handleChange}
          values={values.receiver?.passportCode}
          important
          error={
            touched.receiver?.passportCode && errors.receiver?.passportCode
          }
          wrapperClassName="w-full"
        />
        <InputNumber
          label="کد آمایش"
          name="receiver.amayeshCode"
          handleChange={setFieldValue}
          values={values.receiver?.amayeshCode}
          important
          error={touched.receiver?.amayeshCode && errors.receiver?.amayeshCode}
          wrapperClassName="w-full"
          notSeparator
        />
        <InputText
          ref={reveiverRef}
          label="نام و نام خانوادگی"
          name="receiver.name"
          handleChange={handleChange}
          values={values.receiver.name}
          important
          error={touched?.receiver?.name && errors.receiver?.name}
          wrapperClassName="w-full"
          classNames="bg-white"
          leftIcon={
            <RenderIcon
              isListening={isListening}
              startListening={() => startListening("receiver.name")}
              stopListening={stopListening}
            />
          }
          handleKeyDown={(e) => handleKeyDown(e, "receiver.name")}
        />

        <InputText
          dir="ltr"
          label="موبایل"
          name="receiver.mobile"
          handleChange={handleChange}
          values={values.receiver.mobile}
          important
          error={touched?.receiver?.mobile && errors?.receiver?.mobile}
          wrapperClassName="w-full"
          classNames="bg-white"
          maxLength={13}
          leftIcon={
            <RenderIcon
              isListening={isListening}
              startListening={() => startListening("receiver.mobile", true)}
              stopListening={stopListening}
            />
          }
          handleKeyDown={(e) => handleKeyDown(e, "receiver.mobile", true)}
        />

        <InputSelect
          handleKeyDown={(e) =>
            handleKeyDown(
              e,
              "receiver.receiverCityId",
              false,
              "object",
              contentType?.options
            )
          }
          label="شهر مقصد"
          important
          name="receiver.receiverCityId"
          handleChange={(name, value) => handleChangeCity(name, value)}
          values={values.receiver.receiverCityId}
          error={
            touched.receiver?.receiverCityId && errors.receiver?.receiverCityId
          }
          options={contentType?.options}
          wrapperClassName="w-full"
          customFilter={searchByCity}
          icon={
            <RenderIcon
              isListening={isListening}
              startListening={() =>
                startListening(
                  "receiver.receiverCityId",
                  false,
                  "object",
                  contentType?.options
                )
              }
              stopListening={stopListening}
            />
          }
        />
        <div className="flex  gap-2 w-full  ">
          <InputText
            classNames="bg-white"
            wrapperClassName="w-full"
            important
            leftIcon={
              <div className="flex gap-3 items-center">
                <button type="button" onClick={() => setOpenScan(!openScan)}>
                  <BsUpcScan size={30} className="text-[#EAB308] " />
                </button>
              </div>
            }
            placeholder="شماره مرسوله  را وارد کنید یا اسکن کنید"
            handleChange={handleChange}
            name="cprNumber"
            values={values.cprNumber}
            error={touched.cprNumber && errors.cprNumber}
            maxLength={13}
            readOnly
          />

          <SimpleButton
            text={"ثبت بارکد"}
            handelClick={getFreeBarcode}
            loading={freeBardoce?.loading}
            className=" border border-tomato bg-white w-[8rem] "
            disabled={!!freeBardoce?.data}
          />
        </div>
        <MultiLineText
          label="آدرس"
          important
          values={values.receiver.address}
          name="receiver.address"
          handleChange={handleChange}
          error={touched.receiver?.address && errors.receiver?.address}
          classNames="bg-white"
          wrapperClassName="col-span-2 Max-md:col-span-1 relative"
          row={2}
          icon={
            <RenderIcon
              isListening={isListening}
              startListening={() => startListening("receiver.address")}
              stopListening={stopListening}
            />
          }
          handleKeyDown={(e) => handleKeyDown(e, "receiver.address")}
        />
      </div>
    </>
  );
};

export default Receiver;
